import {useMemo, useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css';

import 'assets/css/wheelpicker.css';
import Wheel from './Wheel';
import {diabetYearsArray} from '../items';
import ButtonContainer from './ButtonContainer';

const DiabetYear = ({changeHandler, closeToastHandler, value}) => {
  const [selectedItem, setSelectedItem] = useState();

  const diabetYears = useMemo(() => diabetYearsArray(), []);

  return (
    <>
      <div style={{width: '100%', height: '250px'}}>
        <Wheel
          loop
          width={300}
          setSelected={setSelectedItem}
          length={diabetYears?.length}
          perspective='center'
          items={diabetYears}
          diabetYearWidth
          year={true}
          initIdx={value}
        />
      </div>
      <ButtonContainer
        closeToastHandler={closeToastHandler}
        changeHandler={changeHandler}
        value={selectedItem?.rel}
      />
    </>
  );
};

export default DiabetYear;
